import axios from 'axios';

// ARTIK GERÇEK SUNUCUYA BAĞLANIYORUZ! 🚀
const BACKEND_URL = 'https://giresunkent.onrender.com'; 
const API = BACKEND_URL + '/api';

// Axios istemcisini oluştur
const apiClient = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Her istekte token var mı kontrol et ve ekle
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// Hataları yakala
apiClient.interceptors.response.use((response) => {
  return response;
}, (error) => {
  if (error.response && error.response.status === 401) {
    // Yetkisiz giriş ise sessizce token'ı silme, belki yenilenebilir.
    // localStorage.removeItem('token'); 
  }
  return Promise.reject(error);
});

// --- API SERVİSLERİ ---

// 1. KİMLİK DOĞRULAMA (SORUNU ÇÖZECEK KISIM) 🛠️
export const authApi = {
  // Sistem önce bunu dener
  getCurrentUser: async () => {
    try {
      // Önce standart /auth/me adresini dene
      const response = await apiClient.get('/auth/me');
      return response.data;
    } catch (error) {
      // Eğer 404 verirse (ki şu an veriyor), yedek kapıyı (/user/profile) dene
      console.warn("Auth/me bulunamadı, user/profile deneniyor...");
      const fallbackResponse = await apiClient.get('/user/profile');
      return fallbackResponse.data;
    }
  },
  login: async (credentials) => {
    const response = await apiClient.post('/auth/login', credentials);
    return response.data;
  },
  register: async (data) => {
    const response = await apiClient.post('/auth/register', data);
    return response.data;
  }
};

// 2. KULLANICI İŞLEMLERİ
export const userApi = {
  getProfile: async () => {
    const response = await apiClient.get('/user/profile');
    return response.data;
  },
  updateProfile: async (data) => {
    const response = await apiClient.put('/user/profile', data);
    return response.data;
  }
};

// 3. BİLDİRİMLER
export const notificationsApi = {
  getAll: async () => {
    const response = await apiClient.get('/notifications');
    return response.data;
  },
  markAsRead: async (id) => {
    const response = await apiClient.put(`/notifications/${id}/read`);
    return response.data;
  },
  getUnreadCount: async () => {
    const response = await apiClient.get('/notifications/unread-count');
    return response.data;
  }
};

// 4. MESAJLAR
export const messagesApi = {
  getConversations: async () => {
    const response = await apiClient.get('/chat/conversations');
    return response.data;
  },
  getMessages: async (conversationId) => {
    const response = await apiClient.get(`/chat/conversations/${conversationId}/messages`);
    return response.data;
  },
  sendMessage: async (recipientId, content) => {
    const response = await apiClient.post('/chat/messages', { recipient_id: recipientId, content });
    return response.data;
  }
};

// 5. GEZİLER (TRIPS)
export const tripsApi = {
  getAll: async () => {
    const response = await apiClient.get('/trips');
    return response.data;
  },
  getById: async (id) => {
    const response = await apiClient.get(`/trips/${id}`);
    return response.data;
  },
  create: async (data) => {
    const response = await apiClient.post('/trips', data);
    return response.data;
  }
};

// 6. MEKANLAR
export const placesApi = {
  getAll: async (category = null, search = null) => {
    const params = new URLSearchParams();
    if (category && category !== 'all') params.append('category', category);
    if (search) params.append('search', search);
    const response = await apiClient.get(`/places?${params.toString()}`);
    return response.data;
  },
  getFeatured: async () => {
    const response = await apiClient.get('/places/featured');
    return response.data;
  },
  getById: async (id) => {
    const response = await apiClient.get(`/places/${id}`);
    return response.data;
  }
};

// 7. ROTALAR
export const routesApi = {
  getAll: async () => {
    const response = await apiClient.get('/routes');
    return response.data;
  },
  getPopular: async () => {
    const response = await apiClient.get('/routes/popular');
    return response.data;
  },
  getById: async (id) => {
    const response = await apiClient.get(`/routes/${id}`);
    return response.data;
  }
};

// 8. KATEGORİLER
export const categoriesApi = {
  getAll: async () => {
    const response = await apiClient.get('/categories');
    return response.data;
  }
};

// 9. FAVORİLER
export const favoritesApi = {
  getAll: async () => {
    const response = await apiClient.get('/user/favorites');
    return response.data;
  },
  toggle: async (placeId) => {
    const response = await apiClient.post(`/user/favorites/${placeId}/toggle`);
    return response.data;
  }
};

// 10. İŞLETMELER
export const businessesApi = {
  getAll: async (category = null, search = null) => {
    const params = new URLSearchParams();
    if (category && category !== 'all') params.append('category', category);
    if (search) params.append('search', search);
    const response = await apiClient.get(`/businesses?${params.toString()}`);
    return response.data;
  },
  getById: async (id) => {
    const response = await apiClient.get(`/businesses/${id}`);
    return response.data;
  }
};

// 11. KAMPANYALAR
export const campaignsApi = {
  getAll: async (active = null) => {
    const params = active !== null ? `?active=${active}` : '';
    const response = await apiClient.get(`/campaigns${params}`);
    return response.data;
  },
  getById: async (id) => {
    const response = await apiClient.get(`/campaigns/${id}`);
    return response.data;
  },
  use: async (campaignId) => {
    const response = await apiClient.post(`/campaigns/${campaignId}/use`);
    return response.data;
  }
};

// 12. TOPLULUK (COMMUNITY)
export const communityApi = {
  getPosts: async () => {
    const response = await apiClient.get('/community/posts');
    return response.data;
  },
  getTrending: async () => {
    const response = await apiClient.get('/community/trending');
    return response.data;
  },
  getLocalGuides: async () => {
    const response = await apiClient.get('/community/local-guides');
    return response.data;
  },
  createPost: async (content, placeId = null, image = null, category = null, rating = null, taggedUsers = []) => {
    const body = { content, place_id: placeId, image, category, rating, tagged_users: taggedUsers };
    const response = await apiClient.post('/community/posts', body);
    return response.data;
  },
  toggleVisited: async (postId) => {
    const response = await apiClient.post(`/community/posts/${postId}/visited`);
    return response.data;
  },
  toggleSave: async (postId) => {
    const response = await apiClient.post(`/community/posts/${postId}/save`);
    return response.data;
  },
  toggleFollow: async (userId) => {
    const response = await apiClient.post(`/community/follow/${userId}`);
    return response.data;
  },
  getFollowingList: async () => {
    const response = await apiClient.get('/community/following');
    return response.data;
  },
  getUserProfile: async (userId) => {
    const response = await apiClient.get(`/community/users/${userId}/profile`);
    return response.data;
  }
};
